import { respostaNaoFormatadaByPerguntaId } from "../../utils/getRespostasNaoFormatadas";

const opcaoSimNao = (resposta) => {
  if (resposta === "50") {
    return true;
  }

  if (resposta === "51") {
    return false;
  }

  return null;
};
export default function Insert(respostas, campos) {
  campos.setAnamnese(respostaNaoFormatadaByPerguntaId(respostas, 1));
  campos.setEstadoInicioDoenca(respostaNaoFormatadaByPerguntaId(respostas, 2));
  campos.fetchMunicipio(respostaNaoFormatadaByPerguntaId(respostas, 2));
  campos.setMunicipioInicioDoenca(
    respostaNaoFormatadaByPerguntaId(respostas, 3)
  );

  campos.setTempoMoradiaMunicipio(
    respostaNaoFormatadaByPerguntaId(respostas, 4)
  );
  campos.setLocalPrimeiroSintoma(
    respostaNaoFormatadaByPerguntaId(respostas, 5)
  );

  campos.setDataPrimeiroSintoma(
    respostaNaoFormatadaByPerguntaId(respostas, 6).split("-", 2).join("-")
  );

  campos.setIdadeInicioSintomas(respostaNaoFormatadaByPerguntaId(respostas, 7));

  campos.setAltura(respostaNaoFormatadaByPerguntaId(respostas, 8));
  campos.setPeso(respostaNaoFormatadaByPerguntaId(respostas, 9));
  campos.setImc(respostaNaoFormatadaByPerguntaId(respostas, 10));

  campos.setSinaisSintomas(respostaNaoFormatadaByPerguntaId(respostas, 11));
  campos.setSinaisSintomasOutros(
    respostaNaoFormatadaByPerguntaId(respostas, 12) || []
  );

  campos.setAntecedentesPessoais(
    respostaNaoFormatadaByPerguntaId(respostas, 13)
  );
  campos.setAntecedentesPessoaisOutros(
    respostaNaoFormatadaByPerguntaId(respostas, 14) || []
  );

  campos.setComorbidadesSelecionadas(
    respostaNaoFormatadaByPerguntaId(respostas, 15)
  );
  campos.setComorbidadesOutras(
    respostaNaoFormatadaByPerguntaId(respostas, 16) || []
  );

  campos.setCirurgias((prevState) => ({
    ...prevState,
    checked: opcaoSimNao(respostaNaoFormatadaByPerguntaId(respostas, 17)),
    tagCirurgias: respostaNaoFormatadaByPerguntaId(respostas, 18) || [],
  }));

  campos.setHistoricoFamiliarDoencaPsiquiatrica(
    respostaNaoFormatadaByPerguntaId(respostas, 203)
  );
  campos.setHistoricoDoencaPsiquiatricaOutros(
    respostaNaoFormatadaByPerguntaId(respostas, 25)
  );
  campos.setHistoricoFamiliarDemencia(
    respostaNaoFormatadaByPerguntaId(respostas, 202)
  );
  campos.setHistoricoFamiliarDemenciaOutros(
    respostaNaoFormatadaByPerguntaId(respostas, 23)
  );
  campos.setHistoricoFamiliarELA(
    respostaNaoFormatadaByPerguntaId(respostas, 201)
  );
  campos.setHistoricoFamiliarELAOutros(
    respostaNaoFormatadaByPerguntaId(respostas, 21)
  );

  campos.setUsoRiluzol((prevState) => ({
    ...prevState,
    checked:
      respostaNaoFormatadaByPerguntaId(respostas, 26) == "50" ? true : false,
    dataInicioUso: respostaNaoFormatadaByPerguntaId(respostas, 27),
  }));

  campos.setMedicamentosUsados(
    respostaNaoFormatadaByPerguntaId(respostas, 28) || []
  );
  campos.setAlergiasOuReacoes((prevState) => ({
    ...prevState,
    alimentos: respostaNaoFormatadaByPerguntaId(respostas, 30) || [],
    medicamentos: respostaNaoFormatadaByPerguntaId(respostas, 31) || [],
    outros: respostaNaoFormatadaByPerguntaId(respostas, 32) || [],
  }));

  campos.setObservacoes(respostaNaoFormatadaByPerguntaId(respostas, 33));

  let alimentos =
    respostaNaoFormatadaByPerguntaId(respostas, 30).length > 0 ? true : false;
  let medicamentos =
    respostaNaoFormatadaByPerguntaId(respostas, 31).length > 0 ? true : false;
  let outros =
    respostaNaoFormatadaByPerguntaId(respostas, 32).length > 0 ? true : false;

  campos.setChecks((prevState) => ({
    ...prevState,
    alimentos: alimentos,

    medicamentos: medicamentos,

    outros: outros,

    historicoELA: opcaoSimNao(respostaNaoFormatadaByPerguntaId(respostas, 20)),
    historicoDemencia: opcaoSimNao(
      respostaNaoFormatadaByPerguntaId(respostas, 22)
    ),
    historicoDoencaPsiquiatrica: opcaoSimNao(
      respostaNaoFormatadaByPerguntaId(respostas, 24)
    ),
    alergiasOuReacoes: alimentos || medicamentos || outros,
  }));
}
